import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import "./ForceUpdateModal.scss";

interface ForceUpdateModalProps {
	onReload: () => void;
}

const ForceUpdateModal: FC<ForceUpdateModalProps> = ({ onReload }) => {
	const { t } = useTranslation();

	return (
		<div className="ForceUpdateModal" data-testid="force-update-modal">
			<div className="ForceUpdateModal__backdrop" />
			<div className="ForceUpdateModal__content">
				<h2 className="ForceUpdateModal__title">{t("forceUpdate.title")}</h2>
				<p className="ForceUpdateModal__message">{t("forceUpdate.message")}</p>
				<button className="ForceUpdateModal__button" onClick={onReload}>
					{t("forceUpdate.reload")}
				</button>
			</div>
		</div>
	);
};

export default ForceUpdateModal;
